export class OPSequence{
    OPSequenceNo: string;
    OPSeqDesc: string;
    AssetWorkOrderID: number;
    StartDate:Date;
    CompletionDate:Date;
    ConvertedStartDate:string;
    ConvertedCompletionDate:string;

}